module.exports = __webpack_public_path__ + "static/media/avatar_21.7519a371.svg";